import React, {useEffect} from 'react';
import { focusElemnt } from './helper';
import { tCommon,OK } from '../../translations/Common';

const Alert = ({ msg, error = false, success = false, close, className = '' }) => {
    let textInput = null
    useEffect (() => {
      focusElemnt(`okayButton`)
    }, [])
    return (
      <div className="alert" onClick={close}>
        <div
          className={`alert--content${error ? ' error' : ''}${success ? ' success' : ''} ${className}`}
          onClick={(e) => e.stopPropagation()}
        >
          {msg}
          {
            <button
              id={`okayButton`}
              style={{ display: 'block' }}
              ref={(button) => {
                textInput = button
              }}
              className="err-btn btn btn-primary"
              onClick={() => close()}
            >
              {tCommon(OK)}
            </button>
          }
        </div>
      </div>
    )
  }
  
  export default Alert